<template>
    <div>
        <van-popup v-model="show">
            <div class="dialog-content" v-if="download">
                <div class="close-btn" @click="show = false">
                    <van-icon :size="18" name="cross" />
                </div>
                <div class="icon-wrapper">
                    <img
                        src="./file-icon.png"
                        width="100%"
                        height="100%"
                        alt=""
                    />
                </div>
                <p class="text">保单详情</p>
                <a href="javascript:;" class="btn" @click="submit">立即下载</a>
            </div>
            <div v-else class="dialog-content confirm">
                <h3 class="title">温馨提示</h3>
                <p class="text">暂无可下载的保单详情</p>
                <a href="javascript:;" class="btn" @click="submit">确定</a>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false,
            download: true,
        };
    },
    methods: {
        submit() {
            this.show = false;
            if (this.download) {
                this.sensorsAdd("BDWebClick", {
                    $element_content: "立即下载",
                    $title: "理念导入页",
                });
                this.$emit("confirm");
            }
        },
    },
};
</script>
<style scoped>
.van-popup {
    background-color: transparent;
}
.dialog-content {
    width: 2.36rem;
    height: 2.64rem;
    border-radius: 0.09rem;
    background-color: #fff;
    overflow: hidden;
}
.dialog-content.confirm {
    width: 2.8rem;
    height: 1.56rem;
}
.dialog-content .close-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 0.4rem;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    color: #166fbe;
}
.icon-wrapper {
    width: 1.09rem;
    height: 0.99rem;
    margin: 0.53rem auto 0;
}
.dialog-content .title {
    padding-top: 0.2rem;
    font-size: 0.15rem;
    text-align: center;
    color: #0f2742;
}
.dialog-content .text {
    line-height: 0.6rem;
    font-size: 0.14rem;
    color: #0f2742;
    text-align: center;
}
.dialog-content .btn {
    display: block;
    width: 1.68rem;
    height: 0.33rem;
    line-height: 0.33rem;
    text-align: center;
    margin: 0 auto;
    font-size: 0.14rem;
    font-weight: bold;
    color: #fff;
    background-color: #3b97ff;
    border-radius: 0.16rem;
}
.dialog-content.confirm .btn {
    width: 0.79rem;
}
</style>
